import * as React from "react"
import type { SVGProps } from "react"
const SvgMinusSquareFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8 13h8q.42 0 .71-.29A1 1 0 0 0 17 12a1 1 0 0 0-.29-.71A1 1 0 0 0 16 11H8a1 1 0 0 0-.71.29A1 1 0 0 0 7 12a.97.97 0 0 0 1 1m-3 8q-.82 0-1.41-.59A2 2 0 0 1 3 19V5q0-.82.59-1.41A2 2 0 0 1 5 3h14q.83 0 1.41.59.6.59.59 1.41v14q0 .83-.59 1.41A2 2 0 0 1 19 21z" />
  </svg>
)
export default SvgMinusSquareFilled
